import React from 'react';
import PropTypes from "prop-types";
import {TreeSelect} from "antd"
import Text from 'antd/lib/typography/Text';
import I18n from '../../common/I18n';
const { TreeNode } = TreeSelect;

function AccountCodesFilter (props) {
  const { SelectedAccountCodes, onValueChange , accounts, size="small", element = 'accountCodes', valueField="id", styleObject={}, showLabel = false, loading = false } = props;
  return (
    <div className="AccountCodesFilterContainer" data-testid="account-filter-dropdown">
      {showLabel && <Text className="marginRight5 textBold">{I18n.t("general.account")}:</Text>}
      <TreeSelect
        value={ SelectedAccountCodes }
        style={ { width: '100%', ...styleObject } }
        showSearch
        size={size || "small"}
        className="minWidth"
        dropdownStyle={ {
          maxHeight: 300,
          overflow: "auto",
        } }
        placeholder="--Select--"
        allowClear={!loading}
        treeDefaultExpandAll
        dropdownMatchSelectWidth={ false }
        onChange={ (e) =>
          onValueChange(element, e)
        }
        treeCheckable
        maxTagCount={ 1 }
        treeNodeFilterProp="title"
        disabled={loading}
        filterOption={(input, option) =>
          option.props.children
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        }
      >
        <TreeNode value="ALL" title="All" key="0-1">
          { accounts.map((account) => (
            <TreeNode
              value={ account[valueField] }
              title={ `${account.name} (${account.code})` }
              key={ account.id }
            />
          )) }
        </TreeNode>
      </TreeSelect>
    </div>
  );
}

export default AccountCodesFilter;

AccountCodesFilter.propTypes = {
  SelectedAccountCodes: PropTypes.array,
  onValueChange: PropTypes.func,
  accounts: PropTypes.array,
  loading: PropTypes.bool,
};

AccountCodesFilter.defaultProps = {
  SelectedAccountCodes: [],
  onValueChange: () => {},
  accounts: [],
  loading: false,
};